import { ErrorModel } from "@models/micro/error.model";
import {IncidentInt, ErrorMicroInt, ErrorInt, ErrorMicroUnknowInt} from "@interfaces/*";

export class ErrorAdapter {
  static adapt(error: IncidentInt | ErrorMicroInt | ErrorMicroUnknowInt| any): ErrorModel {
    
    const errorAdapt = new ErrorModel(error);
    
    if(ErrorAdapter.isError(error)) {
      errorAdapt.withCode('99');
      errorAdapt.withMessage(error.reason);
      errorAdapt.withRaw(error);
    }
    if(ErrorAdapter.isErrorUnknow(error)) {
      errorAdapt.withCode('99');
      errorAdapt.withMessage(error.error);
      errorAdapt.withRaw(error);
    }
    if(ErrorAdapter.isMonoliteError(error)) {
      errorAdapt.withCode(error.code);
      errorAdapt.withMessage(error.msg);
      errorAdapt.withRaw(error);
    }
    return errorAdapt;
  }

  private static isMonoliteError(error: any): error is ErrorInt{
    return error && ( 'code' in error || 'error' in error);
  }
  private static isError(error: any): error is ErrorMicroInt {
    return error && ('httpcode' in error || 'reason' in error);
  }

  private static isErrorUnknow(error: any): error is ErrorMicroUnknowInt {
    return error && ('status' in error || 'error' in error);
  }

}
